export default __webpack_public_path__ + "static/0187-2d10106c23b24c88dabf765342aba956.png";